import React from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import TrustBar from './TrustBar';
import Products from './Products';
import WhyOpenSov from './WhyOpenSov';
import ProductShowcase from './ProductShowcase';
import Enterprise from './Enterprise';
import UseCases from './UseCases';
import Metrics from './Metrics';
import Testimonials from './Testimonials';
import BlogTeaser from './BlogTeaser';
import FinalCTA from './FinalCTA';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-app text-content overflow-x-hidden font-sans selection:bg-[#10B981]/20">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Products />
        <WhyOpenSov />
        <ProductShowcase />
        <Enterprise />
        <UseCases />
        <Metrics />
        <Testimonials />
        <BlogTeaser />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
